import { render, staticRenderFns } from "./vasList.vue?vue&type=template&id=4bf37094&scoped=true&"
import script from "./vasList.vue?vue&type=script&lang=js&"
export * from "./vasList.vue?vue&type=script&lang=js&"
import style0 from "./vasList.vue?vue&type=style&index=0&id=4bf37094&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf37094",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf37094')) {
      api.createRecord('4bf37094', component.options)
    } else {
      api.reload('4bf37094', component.options)
    }
    module.hot.accept("./vasList.vue?vue&type=template&id=4bf37094&scoped=true&", function () {
      api.rerender('4bf37094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/vasList.vue"
export default component.exports